import { Mapper } from '@data/base/mapper';
import { UserEntity } from '@domain/dto/auth/auth-get.dto';

export class UserMapper extends Mapper<UserEntity> {
  fromJson(param: any): UserEntity {
    return param;
  }
}
